import obfuscation from './obfuscation';
import vin from './vin';
import registrationNumber from './registrationNumber';

export const car = {
  ...obfuscation,
  ...vin,
  ...registrationNumber,
};
